import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAppClients(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/app-clients', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteAppClient(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/app-clients/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
